module.exports = __webpack_public_path__ + "img/fankui_banner_hk.c3b0a6b5.jpg";